import { createSlice } from '@reduxjs/toolkit';

/**
 * Stores server-driven feature flags fetched from SDK.getAvailableFeatures().
 *
 * Rules:
 *  - `loaded: false` until the first API response arrives.
 *  - All flags default to `true` (optimistic — show everything until server says otherwise).
 *  - Use `useChatFeature(name)` hook (in subFeatureRegistry) to check both server + dev flags.
 */
const initialState = {
   loaded: false,

   // Chat features
   isGroupChatEnabled: true,
   isRecentChatSearchEnabled: true,
   isClearChatEnabled: true,
   isDeleteChatEnabled: true,
   isStarMessageEnabled: true,
   isDeleteMessageEnabled: true,
   isViewAllMediasEnabled: true,
   isTranslationEnabled: true,
   isBlockEnabled: true,
   isReportEnabled: true,

   // Attachment features
   isAttachmentEnabled: true,
   isImageAttachmentEnabled: true,
   isVideoAttachmentEnabled: true,
   isAudioAttachmentEnabled: true,
   isDocumentAttachmentEnabled: true,

   // Call features
   isOneToOneCallEnabled: true,
   isGroupCallEnabled: true,
};

const featuresSlice = createSlice({
   name: 'features',
   initialState,
   reducers: {
      /**
       * Called once after SDK.getAvailableFeatures() returns.
       * Merges the server response into state and marks `loaded: true`.
       */
      setAvailableFeatures(state, action) {
         const data = action.payload || {};
         return { ...initialState, ...data, loaded: true };
      },
   },
});

export const { setAvailableFeatures } = featuresSlice.actions;
export const featuresReducer = { features: featuresSlice.reducer };
export default featuresSlice;
